import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {CargoEntity, GrupoCargoEntity} from '../entities/cargo.entity';
import {
  DUPLICARCARGO,
  EDITCARGO, EDITGRUPOCARGO,
  GETCARGO,
  GETCARGOS,
  GETGRUPOCARGO,
  GETGRUPOSCARGOS,
  NEWCARGO,
  NEWGRUPOCARGO
} from '../queries/cargo.query';

@Injectable()
export class CargoServices {

  constructor(private apollo: Apollo) {
  }

  getCargos() {
    return this.apollo.query<any>({
      query: GETCARGOS
    });
  }

  getCargo(id: any) {
    return this.apollo.query<any>({
      query: GETCARGO,
      variables: {
        id: id
      }
    });
  }

  editCargo(cargo: CargoEntity) {
    return this.apollo.mutate<any>({
      mutation: EDITCARGO,
      variables: {
        cargo: JSON.stringify(cargo)
      }
    });
  }

  newCargo(cargo: CargoEntity) {
    return this.apollo.mutate<any>({
      mutation: NEWCARGO,
      variables: {
        cargo: JSON.stringify(cargo)
      }
    });
  }

  duplicarCargo(id: string) {
    return this.apollo.mutate<any>({
      mutation: DUPLICARCARGO,
      variables: {
        id: id
      }
    });
  }

  getGruposCargos(){
    return this.apollo.query({
      query:GETGRUPOSCARGOS
    })
  }

  getGrupoCargo(id:any){
    return this.apollo.query({
      query:GETGRUPOCARGO,
      variables:{
        id:id
      }
    })
  }

  newGrupoCargo(grupo:GrupoCargoEntity){
    return this.apollo.mutate<any>({
      mutation: NEWGRUPOCARGO,
      variables: {
        grupo: JSON.stringify(grupo)
      }
    });

  }

  editGrupoCargo(grupo:GrupoCargoEntity){
    return this.apollo.mutate<any>({
      mutation: EDITGRUPOCARGO,
      variables: {
        grupo: JSON.stringify(grupo)
      }
    });

  }

}
